import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Layout from "@/components/Layout";
import Seo from "@/components/Seo";
import PoojaCard from "@/components/PoojaCard";
import { getPoojas, CATEGORIES } from "@/lib/api";

const Poojas = () => {
  const [cat, setCat] = useState("all");
  const { data: poojas = [], isLoading, isError } = useQuery({ queryKey: ["poojas", "all"], queryFn: () => getPoojas() });
  const filtered = cat === "all" ? poojas : poojas.filter((p) => p.category === cat);

  return (
    <Layout>
      <Seo
        title="All Poojas in Gokarna | Booking with Authentic Temple Priests"
        description="Browse all poojas available at Gokarna — Rudrabhishek, Rahu Ketu, Mangal Dosha, Maha Mrityunjaya Homa and more. Filter by purpose. Transparent pricing & WhatsApp booking."
      />
      <section className="bg-secondary text-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12 py-16">
          <span className="text-xs tracking-[0.2em] uppercase font-semibold text-gold">Our Poojas</span>
          <h1 className="mt-2 font-heading text-4xl sm:text-5xl text-white tracking-tight">Poojas at Gokarna Mahabaleshwar Temple</h1>
          <p className="mt-4 max-w-2xl text-white/80">Authentic Vedic rituals performed by our main priest team. Choose by purpose, or message us for honest guidance.</p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12 py-10">
        <div className="flex flex-wrap gap-2 mb-10" data-testid="pooja-filters">
          {CATEGORIES.map((c) => (
            <button
              key={c.value}
              onClick={() => setCat(c.value)}
              data-testid={`filter-${c.value}`}
              className={`rounded-full px-4 py-2 text-sm font-medium border transition-colors ${
                cat === c.value ? "bg-primary text-white border-primary" : "bg-white text-secondary border-border hover:border-primary"
              }`}
            >
              {c.label}
            </button>
          ))}
        </div>

        {isLoading ? (
          <p className="text-muted-foreground">Loading poojas…</p>
        ) : isError ? (
          <div className="text-center py-16" data-testid="poojas-error">
            <p className="text-secondary font-medium">We couldn't load the poojas right now.</p>
            <button onClick={() => window.location.reload()} className="mt-4 rounded-md bg-primary px-6 py-3 font-semibold text-white hover:bg-[#CC5204]">Try Again</button>
          </div>
        ) : filtered.length === 0 ? (
          <p className="text-muted-foreground" data-testid="no-poojas">No poojas in this category yet.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {filtered.map((p, i) => <PoojaCard key={p.id} pooja={p} index={i} />)}
          </div>
        )}
      </section>
    </Layout>
  );
};

export default Poojas;
